import { fetchConToken, fetchSinToken } from "../../helpers/fetch/fetch";
import { contacts } from "../../models/contacts/contacts.model";
import { datosUsuarioRequest } from '../../models/usuarios/usuarios.models';

export async function obtenerDatosEmpresa(idUsuario: number) {
    try {
        const resp = await fetchSinToken('contactosUsuario/obtenerDatosEmpresa/' + idUsuario);
        const body = resp.json();
        return body;
    } catch {
        return { success : false }
    }
}

export async function descargarVCard(idUsuarioElsa: number, idUsuario:number) {
    try {
        const resp = await fetchSinToken(`contactosUsuario/descargarvCard/${idUsuarioElsa}/${idUsuario}`);
        const body = resp.json();
        return body;
    } catch {
        return { success : false }
    }
}

export async function obtenerDatosEncriptado(idUsuario: string, idEmpresaEncriptado?: string) {
    try {
        const resp = await fetchSinToken(`contactosUsuario/obtenerDatosEmpresaEncriptado/${encodeURIComponent(idUsuario)}${idEmpresaEncriptado ? `?idEmpresa=${idEmpresaEncriptado}` :``}`);
        const body = resp.json();
        return body;
    } catch {
        return { success : false }
    }
}

export async function descargarVCardEncriptado(idUsuarioElsa: string, idUsuario:string, idEmpresa: string) {
    try {
        const resp = await fetchSinToken(`contactosUsuario/descargarvCardEncriptado?idUsuarioElsaEncriptado=${encodeURIComponent(idUsuarioElsa)}&idUsuarioEncriptado=${encodeURIComponent(idUsuario)}&idEmpresa=${encodeURIComponent(idEmpresa)}`);
        const body = resp.json();
        return body;
    } catch {
        return { success : false }
    }
}

export async function newContact(formData: contacts, encriptado: boolean = false) {
    try {
        const resp = await fetchSinToken(!encriptado ? 'contactosUsuario/nuevoContacto' : 'contactosUsuario/nuevoContactoEncriptado', formData, 'POST');
        const body = await resp.json();
        return body;
    } catch {
        return {success: false}
    }
}

export async function obtenerTodosUsuarios() {
    try {
        const resp = await fetchConToken('usuarios/obtenerUsuarios', null, 'GET');
        const body = await resp.json();
        return body;
    } catch (err) {

    }
}

export async function obtenerDatosUsuario(idUsuario: string) {
    try {
        const resp = await fetchConToken(`usuarios/datosUsuario/${idUsuario}`, null, 'GET');
        const body = await resp.json();
        return body;
    } catch (err) {
        return {success: false}
    }
}

export async function guardarDatoPersonalesUsuario(idUsuarioElsa: number, datosUsuarioRequest: datosUsuarioRequest){
    try {
        const resp = await fetchConToken(`usuarios/actualizarInformacionUsuario/${idUsuarioElsa}`, datosUsuarioRequest, 'POST');
        const body = await resp.json();
        return body;
    } catch {
        return { success: false }
    }
}
